import PropTypes from 'prop-types';
import React, {useEffect} from 'react';

import {TYPE_CLICK} from '../../../constants/tagManager';
import {pushInteractionTagManagerChatbot} from '../../../services/tagManager';
import {useLogoutStore} from '../../../store/slices/logoutStore';

const QrCodeContact = '/icons/code-contact.png';
const MessageFinishSimulationImage = '/icons/image-finish-simulation.png';
import './MessageFinishSimulation.style.scss';

const MessageFinishSimulation = (props) => {
  const setGoLogout = useLogoutStore((state) => state.setGoLogout);

  const openPortalPage = () => {
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'none:none:ir-para-portal'
    });
    window.open(
      'https://meuestabelecimento.alelo.com.br/',
      'meuestabelecimento',
      'noopener'
    );
    return '';
  };

  useEffect(() => {
    setGoLogout(true);
    pushInteractionTagManagerChatbot({
      screenName: 'credenciamento:chatbot',
      elementType: 'chat:box:filled',
      elementContent: 'success:none:credenciamento'
    });
  }, []);

  return (
    <div id={props.content.id}>
      <div
        className="message-line"
        id="qrcode"
        data-testid="qrcode"
        data-aut-test="qrcode"
      >
        <div className="message-receive" id="msg-qrcode">
          <div className="message-div" data-aut-test="message-receive-text">
            <p>
              Pronto! Agora é só aguardar. Se quiser{' '}
              <strong>acompanhar seu credenciamento via Whatsapp</strong>, envie
              uma mensagem pra gente aqui{' '}
              <a
                href="https://wa.me/message/AAVBJGQSJY6OI1"
                target="_blank"
                className="link"
                rel="noreferrer"
              >
                nesse link
              </a>{' '}
              ou aponte o seu celular para o QRCode abaixo.
            </p>
            <img
              src={QrCodeContact}
              alt={`QrCode contato por whatsapp`}
              className="qrcode-contact"
            />
          </div>
        </div>
      </div>

      <div
        className="message-line"
        id="contacts-numbers"
        data-testid="contacts-numbers"
        data-aut-test="contacts-numbers"
      >
        <div className="message-receive" id="msg-contacts-numbers">
          <div className="message-div" data-aut-test="message-receive-text">
            <p>
              Ah, e você também receberá a confirmação de credenciamento pelo
              e-mail cadastrado em um prazo de 5 dias úteis. Se tiver dúvidas,
              entre em contato com a nossa Central de Atendimento pelos
              seguintes telefones:
            </p>
            <p>
              <strong>Capitais e Regiões Metropolitanas – 4002-5011.</strong>
            </p>
            <p>
              <strong>Demais Localidades – 0800 570 5011.</strong>
            </p>
          </div>
        </div>
      </div>

      <div
        className="message-line"
        id="message-finish"
        data-testid="message-finish"
        data-aut-test="message-finish"
      >
        <div className="message-receive" id="msg-message-finish">
          <div className="message-div" data-aut-test="message-receive-text">
            <p>
              Aproveite e crie seu acesso no Portal Meu Estabelecimento para
              fazer a gestão do seu negócio de forma prática e gratuita.
            </p>
          </div>
        </div>
      </div>

      <div className="message-line">
        <div className="div-button-finish">
          <button
            id="btn-go-portal"
            data-testid="btn-go-portal"
            data-aut-test="btn-go-portal"
            onClick={() => openPortalPage()}
          >
            Ir para o portal
          </button>
        </div>

        <div className="draw">
          <img src={MessageFinishSimulationImage} alt="Desenho dando tchau" />
        </div>
      </div>
    </div>
  );
};

MessageFinishSimulation.propTypes = {
  content: PropTypes.object
};

export default MessageFinishSimulation;
